import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { Container } from 'react-bootstrap';
import { isValidUUID } from '../../../../src/web/utils/omiUtils';

const propTypes = {
  facility: PropTypes.shape({
    companyId: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    settings: PropTypes.shape({
      softwareProvider: PropTypes.string.isRequired,
      allowWebappsToDisplay: PropTypes.bool.isRequired,
    }).isRequired,
  }).isRequired,
};

const defaultProps = {};

const RentalApp = ({ facility }) => {
  const { companyId, id: facilityId,
    settings: { softwareProvider, allowWebappsToDisplay } } = facility;
  const providerId = softwareProvider === 'storedge' ? 'se' : 'sl';
  const rentalAppURL = process.env.RENTAL_APP_BASE_URL;
  const [onHistoryBack, setOnHistoryBack] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return () => {};
    }

    const getReservationIdFromURL = () => {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('reservationId') || '';
    };

    const { href: url } = window.location;
    const lastParam = url.split('/').filter(Boolean).pop();
    const reservationId = isValidUUID(lastParam) ? lastParam : getReservationIdFromURL();

    const rentalAppElement = document.createElement('rental-app');
    rentalAppElement.setAttribute('data-source', 'voyager');
    rentalAppElement.setAttribute('data-provider-id', providerId);
    rentalAppElement.setAttribute('data-organization-id', companyId);
    rentalAppElement.setAttribute('data-facility-id', facilityId);
    rentalAppElement.setAttribute('data-reservation-id', reservationId);

    const container = document.createElement('div');
    container.id = 'rental-app-wrapper';

    const handleCustomEvent = (event) => {
      const { eventName, data } = event.detail;

      if (eventName !== 'ON_DATA_LOAD') {
        const ele = document.getElementById('storable-units-table-container');
        if (ele) {
          ele.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        }
      }

      if (eventName === 'ON_RESERVATION') {
        const newReservationId = data.reservation.id;
        const reservationURL = new URL(window.location.href);
        reservationURL.searchParams.set('reservationId', newReservationId);
        window.history.pushState({}, '', reservationURL);
      }
    };

    const handlePopState = () => {
      // console.log('Browser back button clicked');
      setOnHistoryBack(prev => !prev);
    };

    const script = document.createElement('script');
    script.src = `${rentalAppURL}rental-app/rental-app.js`;
    script.type = 'module';
    script.onload = () => {
      // console.log('Rental-app script loaded successfully');
      window.addEventListener('storable-webapp-ut-event', handleCustomEvent);
      window.addEventListener('popstate', handlePopState);
    };
    // script.onerror;

    container.appendChild(rentalAppElement);
    container.appendChild(script);

    const rentalAppContainer = document.getElementById('rental-app-container');
    if (rentalAppContainer) {
      rentalAppContainer.innerHTML = '';
      rentalAppContainer.appendChild(container);
    }

    return () => {
      if (rentalAppContainer && container.parentNode === rentalAppContainer) {
        rentalAppContainer.removeChild(container);
      }
      window.removeEventListener('storable-webapp-ut-event', handleCustomEvent);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [providerId, companyId, facilityId, allowWebappsToDisplay, onHistoryBack]);

  return <Container id="rental-app-container"><p>Please wait while we are loading...</p></Container>;
};

RentalApp.propTypes = propTypes;
RentalApp.defaultProps = defaultProps;

RentalApp.fragments = {
  facility: gql`
    fragment RentalAppFacility on Facility {
      settings {
        softwareProvider
        allowWebappsToDisplay
      }
      companyId
      id
    }
  `,
};

export default RentalApp;
